<template>
    <div>
        <section class="content cleafix">
            <form>
                <h1 class="form-head">
                    重置密码
                </h1>
                <div class="form-body">
                    <div class="input-item">
                        <input tabindex="-1" type="text" class="input" name="username" placeholder="请输入邮箱、手机号" required="required" v-model.trim="username" autocomplete="off" @blur="checkUsername()">
                        <span class="input-tips">{{error.username}}</span>
                    </div>
                    <div class="input-item clearfix">
                        <div class="col-xs-12 clearfix">
                            <div class="row clearfix">
                                <div class="col-sm-7 n-p-l">
                                    <input tabindex="-1" type="text" class="input" v-model.trim="verifyCode" placeholder="验证码" @blur="validateCode()">
                                </div>
                                <div class="col-sm-5 n-p-r n-p-l">
                                    <button type="button" class="btn btn-md btn-primary col-xs-12" :disabled="reset.disabled" @click="resendEmailCode()">{{reset.text}}</button>
                                </div>
                            </div>
                            <div class="row">
                                <span class="input-tips">{{error.code}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="input-item">
                        <input tabindex="-1" type="password" class="input" name="password" placeholder="请输入密码" required="required" v-model.trim="password" autocomplete="off">
                    </div>
                    <div class="input-item">
                        <input tabindex="-1" type="password" class="input" name="rpassword" placeholder="请再次输入密码" required="required" v-model.trim="rpassword" autocomplete="off">
                        <span class="input-tips">{{error.password}}</span>
                    </div>
                    <div class="input-item clearfix">
                        <input tabindex="-1" type="button" class="btn btn-md btn-primary col-xs-12" value="重置密码" @click="registerFunc()">
                    </div>
                    <div class="input-item">
                        <h5 class="reg_now">还没有帐号？
                            <router-link :to="{ name: '/auth/register', params: {}}">马上注册</router-link>
                            <router-link :to="{ name: '/auth/login', params: {}}" class="right">直接登录</router-link>
                        </h5>
                    </div>
                </div>
            </form>
        </section>
        <!-- / register end /-->
    </div>
</template>
<script>
export default {
  data: function() {
    return {
      username: "",
      password: "",
      rpassword: "",
      verifyCode: "",
      disabled: true,
      type: 1, // 1 邮箱 2.手机号
      error: {
        username: "",
        password: "",
        code: ""
      },
      validate: [0, 0, 0],
      reset: {
        text: "发送验证码",
        disabled: false,
        timer: null,
        seconds: 60
      }
    };
  },
  computed: {
    validateFlag: function() {
      const that = this;
      let tmp = that.validate.join("");
      return tmp;
    }
  },
  created: function() {
    document.title = `找回密码|${this.global.name}`;
  },
  watch: {
    username: function(now, pre) {
      const that = this;
      that.checkUsername();
    },
    password: function(now, pre) {
      const that = this;
      that.disabled = true;
      if (now !== pre) {
        that.validate[2] = 0;
      }
      if (that.password === "" || that.rpassword === "") {
        that.validate[2] = 0;
        that.error.password = "";
        return;
      }
      if (!that.global.regex.password.test(that.password)) {
        that.validate[2] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      }
      if (that.password === that.rpassword) {
        that.validate[2] = 1;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "111";
      } else {
        that.validate[2] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    },
    rpassword: function(now, pre) {
      const that = this;
      that.disabled = true;
      if (now !== pre) {
        that.validate[2] = 0;
      }
      if (that.password === "" || that.rpassword === "") {
        that.validate[2] = 0;
        that.error.password = "";
        return;
      }
      if (!that.global.regex.password.test(that.rpassword)) {
        that.validate[2] = 0;
        that.error.password = "格式错误：6-16位字符、数字、特殊字符至少包含两种";
        return;
      }
      if (that.password === that.rpassword) {
        that.validate[2] = 1;
        that.error.password = "";
        that.disabled = that.validate.join("") !== "111";
      } else {
        that.validate[2] = 0;
        that.error.password = "两次输入的密码不一致";
      }
    }
  },
  methods: {
    checkUsername: function() {
      const that = this;
      that.disabled = true;
      if (that.global.regex.email.test(that.username)) {
        that.error.username = "";
        that.validate[1] = 1;
        that.disabled = that.validate.join("") !== "111";
        that.type = 1;
      } else if (that.global.regex.phone.test(that.username)) {
        that.error.username = "";
        that.validate[1] = 1;
        that.disabled = that.validate.join("") !== "111";
        that.type = 2;
      } else {
        that.validate[1] = 0;
        that.error.username = "请输入正确的邮箱、手机号";
      }
    },
    resendEmailCode: function() {
      const that = this;
      that.reset.disabled = true; // 禁用按钮
      if (that.validate[1] === 0) {
        that.error.username = "请输入正确的邮箱、手机号";
        that.reset.disabled = false;
        return;
      }
      that.$http
        .get(
          `/api/v1/auth/password/${that.type === 1
            ? "email"
            : "phone"}_code?${that.type === 1
            ? "email"
            : "phone"}=${that.username}`
        )
        .then(res => {
          if (res.status === 200) {
            let data = res.body;
            if (data.code === 0) {
              // 校验成功
              that.reset.seconds = 60;
              that.reset.text = `${that.reset.seconds}s后，重发`;
              that.reset.timer = setInterval(() => {
                // 倒计时
                if (that.reset.seconds === 0) {
                  that.reset.disabled = false;
                  that.reset.text = `发送验证码`;
                  clearInterval(that.reset.timer);
                  that.reset.timer = null;
                } else {
                  that.reset.seconds--;
                  that.reset.text = `${that.reset.seconds} s后，重发`;
                }
              }, 1000);
            } else {
              that.reset.disabled = false;
              alert(data.msg);
            }
          } else {
            alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
          }
        });
    },
    validateCode: function() {
      const that = this;
      if (that.verifyCode == "") {
        that.disabled = true;
        that.validate[0] = 0;
        that.error.code = "请输入验证码";
        return;
      }
      if (that.global.regex.code.test(that.verifyCode)) {
        that.error.code = "";
        that.validate[0] = 1;
        that.disabled = that.validate.join("") !== "111";
      } else {
        that.error.code = "请输入正确的验证码";
        that.validate[0] = 0;
        that.disabled = true;
      }
    },
    registerFunc: function() {
      const that = this;
      if (that.disabled) {
        alert("请填写完成验证信息后，再进行下一步操作");
        return;
      }
      that.disabled = true;
      let user = {
        username: that.username,
        password: that.password,
        verifyCode: that.verifyCode
      };
      that.$http.put(`/api/v1/auth/set_password`, user).then(res => {
        if (res.status === 200) {
          let data = res.body;
          if (data.code === 0) {
            // 校验成功
            alert("密码重置成功");
            that.$router.push({
              name: "/auth/login",
              query: { username: that.username }
            });
          } else {
            that.disabled = false;
            alert(data.msg);
          }
        } else {
          alert("服务器繁忙，请稍后再重试注册(╯﹏╰）!!!");
        }
      });
    }
  }
};
</script>

<style lang="less">

</style>



// WEBPACK FOOTER //
// reset-password.vue?3612f4bc